import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { FileService } from '../../../service/file.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { FileSignature } from '../../../types/file-signature';
import { MaterialModule } from '../../../../material/material.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-access-code-validation',
  imports: [
    MaterialModule,
    CommonModule,
    ReactiveFormsModule,
  ],
  templateUrl: './access-code-validation.component.html',
  styleUrl: './access-code-validation.component.scss'
})
export class AccessCodeValidationComponent implements OnInit, OnDestroy {
  containerName: string | null = null;
  signature: string | null = null;
  targetFileGuid: string | null = null;
  resultText: string | null = null;
  isUseAccessCode = false;

  accessCodeFormControl = new FormControl('', [Validators.required]);


  private _subscription = new Subscription();
  private _fileService = inject(FileService);
  private _router = inject(Router);

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    this.containerName = urlParams.get('containerName');
    this.signature = urlParams.get('signature');
    this.targetFileGuid = urlParams.get('fileGuid');
    this._subscription = new Subscription();
    this._fileService.updateFileStoreSignature(this.signature || '');
    this._fileService.updateFileStoreContainerName(this.containerName || '');
    this._fileService.updateFileStoreFileGuid(this.targetFileGuid || '');
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  onEnterKey(event: Event): void {
    if (event instanceof KeyboardEvent) {
      event.preventDefault();
      if (this.accessCodeFormControl.valid) {
        this.onSubmit();
      }
    }
  }

  // アクセスコードを検証する
  onSubmit() {
    if (this.accessCodeFormControl.valid) {
      const accessCode = this.accessCodeFormControl.value ?? '';
      this._subscription.add(
        this._fileService.verifyAccessCode(this.containerName!, this.signature!, accessCode).subscribe({
          next: (res: FileSignature) => {
            if (res.accessCodeValidationResult?.isValid) {
              this._fileService.updateFileStoreAccessCode(accessCode);
              this._fileService.updateFileStoreFileSignatureInfo(res);
              // アクセスコードが有効な場合、ダウンロード画面に遷移する
              this._router.navigate(['/download']);
            } else {
              this._fileService.updateFileStoreFileSignatureInfo(res);
              // formControlにエラーメッセージを設定し、touched状態にしてエラーを即座に表示
              this.accessCodeFormControl.setErrors({ invalid: res.accessCodeValidationResult?.message });
              this.accessCodeFormControl.markAsTouched();
            }
          },
          error: (error: FileSignature) => {
            this.navigeteForValidarion(error);
          }
        })
      );
    }
  }

  navigeteForValidarion(result: FileSignature) {
    if (!result.isVerifiedSignature) {
      // シグネチャ不正画面に遷移する
      this._router.navigate(['/error/invalid-signature']);
    }
    if (result.isExpiredUrl) {
      // 有効期限切れ画面に遷移する
      this._router.navigate(['/error/expired']);
    }
    if (result.isLockedAccess) {
      // アクセス制限画面に遷移する
      this._router.navigate(['/error/lock']);
    }
    if (result.isManualDelete) {
      // 手動削除画面に遷移する
      this._router.navigate(['/error/invalid-url']);
    }
  }
}
